import { PAGE_SIZES } from "../hooks/usePagedQuery";
import { n } from "../lib/format";

/**
 * SAYFALAMA ÇUBUĞU.
 *
 * Üç bilgiyi birden verir ve üçü de eksikti:
 *   1. KAÇ KAYIT VAR — "100 kayıt gösteriliyor (en fazla 100)" kullanıcıya
 *      toplamı söylemiyordu. 101 mi var 10.000 mi, bilinmiyordu.
 *   2. NEREDESİN — kaçıncı kayıt aralığına baktığın.
 *   3. NASIL DEVAM EDERSİN — sonraki sayfaya geçiş hiç yoktu; 100. kayıttan
 *      sonrası uygulamadan ERİŞİLEMEZ durumdaydı.
 *
 * Sayfa numarası yerine Önceki/Sonraki: Firestore `offset` desteklemez, sayfa
 * numarası uydurmak tıklandığında yanlış kayıt göstermek olurdu.
 */
export function Pagination({
  page,
  pageSize,
  total,
  shown,
  hasNext,
  hasPrev,
  onNext,
  onPrev,
  onPageSize,
  loading = false,
  className = "",
}: {
  page: number;
  pageSize: number;
  total: number | null;
  shown: number;
  hasNext: boolean;
  hasPrev: boolean;
  onNext: () => void;
  onPrev: () => void;
  onPageSize: (n: number) => void;
  loading?: boolean;
  className?: string;
}) {
  const from = shown === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = (page - 1) * pageSize + shown;

  return (
    <div
      className={`noprint flex flex-wrap items-center justify-between gap-3 border-t border-gray-200 pt-3 ${className}`}
    >
      <div className="flex items-center gap-2 text-sm text-gray-700">
        <label htmlFor="sayfa-boyutu" className="text-gray-600">
          Sayfada
        </label>
        <select
          id="sayfa-boyutu"
          /* `py-1` seçiciyi 29px'e düşürüyordu; tablet/telefonda 44px, masaüstünde eski. */
          className="select w-auto py-1 min-h-[44px] lg:min-h-0"
          value={pageSize}
          onChange={(e) => onPageSize(Number(e.target.value))}
        >
          {PAGE_SIZES.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>
        <span className="text-gray-600">kayıt</span>
      </div>

      <p className="text-sm text-gray-700" aria-live="polite">
        {loading ? (
          "yükleniyor…"
        ) : (
          <>
            <strong className="tabular-nums">
              {n(from)}–{n(to)}
            </strong>{" "}
            {/* Toplam ölçülemediyse UYDURMA: "—" der, yanlış sayı vermez. */}
            <span className="text-gray-600">
              / {total === null ? "—" : n(total)} kayıt
            </span>
          </>
        )}
      </p>

      <div className="flex items-center gap-2">
        <button
          type="button"
          className="btn-secondary"
          onClick={onPrev}
          disabled={!hasPrev || loading}
        >
          ← Önceki
        </button>
        <span className="text-sm tabular-nums text-gray-600">Sayfa {n(page)}</span>
        <button
          type="button"
          className="btn-secondary"
          onClick={onNext}
          disabled={!hasNext || loading}
        >
          Sonraki →
        </button>
      </div>
    </div>
  );
}

export default Pagination;
